import actions from "./actions";

const reducer = (state, action = { type: "", payload: {} }) => {
  return actions(state, action.payload)[action.type]()
}

export default reducer;